/** Saves `text` as a file named after the last segment of `path` (JSON or Markdown by its extension). */
export const download = (path: string, text: string) => {
    const blob = new Blob([text], { type: path.endsWith('.json') ? 'application/json' : 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = path.split('/').pop() || 'file';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
};
